import React, { useState } from 'react';

const HostSelectionModal = ({ isOpen, game, currentHostId, onSelectHost, onCancel }) => {
  const [selectedHostId, setSelectedHostId] = useState(null);

  if (!isOpen) return null;

  // Get all players except current host
  const availablePlayers = Object.entries(game?.players || {})
    .filter(([id]) => id !== currentHostId)
    .sort((a, b) => {
      // Sort by joinedAt (oldest first)
      const timeA = a[1].joinedAt?.seconds || 0;
      const timeB = b[1].joinedAt?.seconds || 0;
      return timeA - timeB;
    });

  const handleConfirm = () => {
    onSelectHost(selectedHostId);
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '1rem'
    }}>
      <div style={{
        background: 'white',
        borderRadius: 'var(--radius-xl)',
        padding: '2rem',
        maxWidth: '500px',
        width: '100%',
        maxHeight: '80vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>👑</div>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
            Select New Host
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            Choose who will become the new host, or skip to auto-select
          </p>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          {availablePlayers.length === 0 ? (
            <div style={{
              padding: '2rem',
              textAlign: 'center',
              color: 'var(--text-secondary)'
            }}>
              No other players in the game
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {availablePlayers.map(([playerId, player]) => (
                <button
                  key={playerId}
                  onClick={() => setSelectedHostId(playerId)}
                  style={{
                    padding: '1rem',
                    background: selectedHostId === playerId ? 'var(--primary)' : 'white',
                    color: selectedHostId === playerId ? 'white' : 'var(--text)',
                    border: `2px solid ${selectedHostId === playerId ? 'var(--primary)' : 'var(--border)'}`,
                    borderRadius: 'var(--radius)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'all 0.2s',
                    fontSize: '1rem',
                    fontWeight: 600
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: selectedHostId === playerId ? 'white' : 'var(--success)',
                      flexShrink: 0
                    }}></div>
                    <span>{player.name}</span>
                  </div>
                  <span style={{
                    fontSize: '0.75rem',
                    opacity: 0.8,
                    fontWeight: 500
                  }}>
                    Team {player.team === 'teamA' ? 'A' : player.team === 'teamB' ? 'B' : '?'}
                  </span>
                </button>
              ))}
            </div>
          )}
        </div>

        <div style={{
          padding: '1rem',
          background: 'var(--bg-tertiary)',
          borderRadius: 'var(--radius)',
          fontSize: '0.75rem',
          color: 'var(--text-secondary)',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>
          {selectedHostId
            ? `${availablePlayers.find(([id]) => id === selectedHostId)?.[1]?.name} will become the new host`
            : 'Skip to auto-select the oldest player as host'}
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '0.75rem'
        }}>
          <button
            onClick={onCancel}
            className="btn btn-outline"
            style={{ fontSize: '0.875rem' }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="btn btn-primary"
            style={{ fontSize: '0.875rem' }}
          >
            {selectedHostId ? 'Confirm' : 'Auto-Select'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostSelectionModal;
